import IHcDate from "./IHcDate";

export default class HcDate implements IHcDate {
    constructor(public date: string) {
    }
}